import styled from 'styled-components';

const Popup = styled.div`
  background-color: #fff;
  width: 80%;
  max-width: 1140px;
  min-width: 1060px;
  height: 510px;
  border-radius: 16px;
  padding: 24px;
  position: relative;
  margin: 100px auto;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
  z-index: 9999;

  h2 {
    text-align: center;
  }
`;

export default Popup;
